import { CSSProperties } from 'react'
import './SquareButtonMobile.css'

type SquareButtonProps = {
  text?: string,
  state?: boolean,
  iconOn?: any,
  iconOff?: any,
  style?: CSSProperties,
  onClick: () => void
}

export default function SquareButtonMobile(props: SquareButtonProps) {

  return (
    <div className='square-button-mobile'
      onClick={() => props.onClick()}
      style={{backgroundColor:props.state===true?"#00A4B6":"transparent"}}
    >
      {props.state === true ? props.iconOn : props.iconOff}
      <p style={{color:props.state==false ? "#A3D8E7" : "#060B0C" ,margin:0, gap:0}}>{props.text}</p>
    </div>
  )
}